import { PortfolioTransactionActionType } from '../../constants';

const portfolioTransactionHistoryReducer = (state = [], action) => {
    switch (action.type) {
        case PortfolioTransactionActionType.FETCH_INVESTED_ASSET:
            return action.payload;
        default:
            return state;
    }
};
export default portfolioTransactionHistoryReducer